import { Component, OnInit, ViewChild  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationResult } from '../../models/account/authenticationResult';
import { Login } from '../../models/account/Login';
import { Redirect } from '../../models/account/redirect';
import { Parameter } from '../../models/account/parameter';
import { AccountService } from '../../services/account/account.service';
import { HelperService } from '../../services/common/helper.service';
import { TranslationService } from '../../services/common/translation.service';
import { TitleService } from '../../services/common/title.service';

const ERROR_TOAST_HIDE_TIMEOUT = 6000

@Component({
    selector: 'login',
    template: require('./../../templates/account/loginForm.component.html'),
    styles: [require('./../../styles/account/loginForm.component.css')],
    providers: [AccountService, HelperService, TranslationService, TitleService]
})
export class LoginFormComponent implements OnInit {
    @ViewChild('ngOtpInput') ngOtpInputRef: any;
    loaded = false;
    login: Login = {
        requestId: undefined,
        username: '',
        password: '',
        rememberLogin: true,
        redirectUrl: '',
        code2FA: ''
    }
    isSuccess: boolean;
    user: AuthenticationResult = {
        requestId: '',
        isAuthenticated: false,
        username: '',
        subjectId: '',
        redirectForm: '',
        redirect: {
            method: '',
            redirectUrl: '',
            parameters: new Array<Parameter>()
        },
        is2FACodeRequired: false,
        is2FASetupRequired: false,
        secret2FA: '',
        pairingUri2FA: ''
  };
  
    errorMessage: string;
    confirmed = false;
    isValid = true;
    isFormValid = true;
    showPass1 = false;
    errorClearTimeout: number;

    //Translations
    formUsername: string;
    loginFormPageTitle: string;
    loginFormDescription: string;
    formSuccess: string;
    loginFormAuthSuccess: string;
    loginFormAuthFail: string;
    loginFormAuthFailReason: string;
    formPassword: string;
    loginFormAuthenticate: string;
    formOops: string;
    loginFormResetPassword: string;

    constructor(private route: ActivatedRoute, private router: Router, private accountService: AccountService, private helperService: HelperService,
        private translationService: TranslationService, private titleService: TitleService) {
        
    }

    ngOnInit() {
        this.loaded = true;
        this.titleService.setTitle(this.route.snapshot.data['title']);
        this.initTranslations();
    }

    initTranslations(){
        this.translationService.translate('form.username', 'Username', (data) => this.formUsername = data);
        this.translationService.translate('loginForm.pageTitle', 'Login Page', (data) => this.loginFormPageTitle = data);
        this.translationService.translate('loginForm.description', 'Use your username and password or certificate for authentication in our system.', (data) => this.loginFormDescription = data);
        this.translationService.translate('form.success', 'Success!', (data) => this.formSuccess = data);
        this.translationService.translate('loginForm.authSuccess', 'Authentication was successful.', (data) => this.loginFormAuthSuccess = data);
        this.translationService.translate('loginForm.authFailed', 'Authentication failed!', (data) => this.loginFormAuthFail = data);
        this.translationService.translate('loginForm.authFailReason', ' Please, check your credentials and try again.', (data) => this.loginFormAuthFailReason = data);
        this.translationService.translate('form.password', 'Password', (data) => this.formPassword = data);
        this.translationService.translate('loginform.authenticate', 'Authenticate', (data) => this.loginFormAuthenticate = data);
        this.translationService.translate('form.oops', 'Oops!', (data) => this.formOops = data);
        this.translationService.translate('loginForm.resetPassword', 'Reset password', (data) => this.loginFormResetPassword = data);
  }



    public resetPassword() {
        this.router.navigate(['reset-password'], { queryParams: { redirectUrl: this.route.snapshot.queryParams.redirectUrl } });
    }

    public confirm() {
        this.loaded = false;
        this.errorMessage = '';
        this.isValid = true;
        this.confirmed = false;

        this.login.redirectUrl = this.route.snapshot.queryParams.redirectUrl;
        if (this.validate()) {
            var result = this.accountService.authenticate(this.login);
            result.subscribe(response => {
                    this.confirmed = true;
                    if (response.success) {
                        this.user = response.data;
                        this.isSuccess = response.data.isAuthenticated;
                        if (response.data.isAuthenticated && response.data.redirect != null) {
							window.location.href = response.data.redirect.redirectUrl;
                        }
                        if (!this.isSuccess) {
                            this.login.requestId = response.data.requestId;
                            if (this.ngOtpInputRef != null) {
                                this.ngOtpInputRef.setValue('');
                            }
                            this.loaded = true;
                        }
                    } else {
                        this.loaded = true;
                        this.isSuccess = false;
                        if (response.errors != null) {
                            this.isValid = false;
                            response.errors.forEach((value) => {
                                this.addError(value.code, value.description, value.values);
                            });
                        }
                    }
                    this.setErrorToastClear();
                },
                error => {
                    this.confirmed = true
                    this.loaded = true;
                    this.isSuccess = false;
                    this.isValid = false;
                    this.addError(error, error, new Array<string>());
                });
        } else {
            this.confirmed = true;
            this.loaded = true;
            this.isSuccess = false;
            this.isValid = false;
            this.setErrorToastClear();
        }
    }

    private setErrorToastClear() {
        clearTimeout(this.errorClearTimeout);
        this.errorClearTimeout = setTimeout(() => {
            this.errorMessage = '';
            this.confirmed = false;
        }, ERROR_TOAST_HIDE_TIMEOUT);
    }

    private addError(code: string, error: string, args : string[]) {
        this.translationService.translate(code, error, (data) => this.errorMessage += '<br /> ' + this.helperService.format(data, args));
        this.setErrorToastClear()
    }

    private submitForm(redirect: Redirect) {
        var form = document.forms[0];
        form.action = redirect.redirectUrl;
        form.method = this.getMethod(redirect);
        while (form.firstChild) {
            form.removeChild(form.firstChild);
        }
        const parameters = redirect.parameters.slice();
        const langParameter: Parameter = {
          name: "culture",
          value: TranslationService.currentCulture.code
        }
        parameters.push(langParameter);

        parameters.forEach((parameter) => {
            var input = document.createElement("input");

            input.setAttribute("type", "hidden");
            input.setAttribute("name", parameter.name);
            input.setAttribute("value", parameter.value);

            form.appendChild(input);
        });

        form.submit();
    }

    onOtpChange(e: string) {
        if (e.length === 6) {
            this.login.code2FA = e;
            this.confirm();
        }
    }

  private getMethod(redirect: Redirect): string {
    var scope = redirect.parameters.find(p => p.name === "scope");
      if (scope != null && scope.value.indexOf("ui") >= 0) {
        return "GET";
      }
      return redirect.method;
    }
    
    private validate() {
        this.isFormValid = true;

        this.errorMessage = '';
        if (this.helperService.isNullOrEmpty(this.login.redirectUrl)) {
            this.addError('loginform.redirectUrlEmpty', 'Redirect Url to external application is not specified', new Array<string>());
            this.isFormValid = false;
        }
        if (this.helperService.isNullOrEmpty(this.login.username)) {
            this.addError('loginform.usernameEmpty', 'Username can not be empty', new Array<string>());
            this.isFormValid = false;
        }
        if (this.helperService.isNullOrEmpty(this.login.password)) {
            this.addError('loginform.passwordEmpty', 'Password can not be empty', new Array<string>());
            this.isFormValid = false;
        }
        return this.isFormValid;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/account/loginForm.component.ts